import { useMemo } from 'react';

import { useAppSelector } from 'state/global-state';
import { selectors } from 'state/global-state';

import { getCmsOffersMapByCmsId } from '../utils';

export const useLoyaltyOffersMap = () => {
  const cmsOffers = useAppSelector(selectors.loyalty.selectCmsOffers);
  const cmsOffersMap = useMemo(() => getCmsOffersMapByCmsId(cmsOffers), [cmsOffers]);
  return cmsOffersMap;
};
